import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="onboarding--tax-id-pending"
//
// Clears and disables the DIČ input when the user says the number has not been
// assigned yet. Without this the field invites placeholder prose ("vybavuje sa"),
// which then freezes onto every document issued before the real number arrives.
//
// The controller root must wrap BOTH the input and the checkbox — see the note in
// onboarding/workspaces/_form.html.erb.
export default class extends Controller {
  static targets = ["input", "checkbox"]

  // Without this, a box rendered already-checked (a re-render after a failed
  // submit) would leave the input enabled and the placeholder prose this feature
  // exists to prevent would stay typeable.
  connect() {
    this.sync()
  }

  toggle() {
    this.sync()
  }

  sync() {
    if (!this.hasInputTarget || !this.hasCheckboxTarget) return

    const pending = this.checkboxTarget.checked
    this.inputTarget.disabled = pending
    if (pending) this.inputTarget.value = ""
  }
}
